import React from "react";
import { FaEnvelope, FaPhone, FaLinkedin, FaGithub, FaFileAlt } from "react-icons/fa";

const card = {
  background: "rgba(255,235,250,0.04)",
  border: "1px solid rgba(255,179,217,0.14)",
  borderRadius: 12,
};

const STATS = [
  { value: "500+", label: "Connections",  icon: "🌐" },
  { value: "5+",   label: "Countries",    icon: "✈️" },
  { value: "6",    label: "Languages",    icon: "🗣️" },
  { value: "10+",  label: "Projects",     icon: "🚀" },
];

const CONTACTS = [
  { icon: <FaEnvelope size={13} />, label: "elarebai.nl@gmail.com",  href: "mailto:elarebai.nl@gmail.com",                      color: "#FFB3D9" },
  { icon: <FaPhone    size={13} />, label: "+216 50 102 891",         href: "tel:+21650102891",                                   color: "#90D8D8" },
  { icon: <FaLinkedin size={13} />, label: "linkedin.com/in/ela-rebai", href: "https://www.linkedin.com/in/ela-rebai-466b77226/", color: "#0A66C2" },
  { icon: <FaGithub   size={13} />, label: "github.com/ela2002",      href: "https://github.com/ela2002",                        color: "#C8A8F0" },
];

const ProfileSection = ({ onNavigate }) => {
  return (
    <div style={{ padding: "24px 20px 32px" }}>

      {/* ── Hero ── */}
      <div style={{ display: "flex", gap: 18, alignItems: "flex-start", marginBottom: 20 }}>
        {/* Portrait with glow ring */}
        <div style={{ position: "relative", flexShrink: 0 }}>
          <div style={{
            position: "absolute", inset: -6, borderRadius: "50%",
            background: "radial-gradient(circle, rgba(255,107,157,0.25) 0%, transparent 70%)",
            animation: "portrait-pulse 3.5s ease-in-out infinite",
          }} />
          <div style={{
            width: 82, height: 82, borderRadius: "50%",
            border: "2px solid rgba(255,179,217,0.45)",
            overflow: "hidden", position: "relative", zIndex: 1,
            boxShadow: "0 0 0 6px rgba(255,179,217,0.06), 0 8px 24px rgba(0,0,0,0.4)",
          }}>
            <img src="/ela3.jpg" alt="Ela Rebai"
              style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center top" }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          </div>
        </div>

        {/* Name + role + status */}
        <div style={{ paddingTop: 4 }}>
          <h3 style={{
            fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic",
            fontSize: "1.65rem", fontWeight: 600, color: "#FFF0F7",
            lineHeight: 1.05, marginBottom: 5,
            textShadow: "0 0 24px rgba(255,107,157,0.2)",
          }}>
            Ela Rebai
          </h3>
          <p style={{
            fontFamily: "'DM Sans', sans-serif", fontSize: "0.74rem",
            color: "rgba(255,179,217,0.65)", fontWeight: 400, letterSpacing: "0.05em",
            marginBottom: 8,
          }}>
            Software Engineer · Data &amp; AI
          </p>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: 6,
            background: "rgba(74,222,128,0.08)", border: "1px solid rgba(74,222,128,0.2)",
            borderRadius: 20, padding: "3px 10px",
          }}>
            <span style={{
              width: 5, height: 5, borderRadius: "50%", background: "#4ade80",
              boxShadow: "0 0 6px #4ade80", flexShrink: 0,
              animation: "status-pulse 2s ease-in-out infinite",
            }} />
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.65rem", color: "rgba(74,222,128,0.85)", fontWeight: 500 }}>
              Open to opportunities
            </span>
          </div>
        </div>
      </div>

      {/* ── Bio ── */}
      <p style={{
        fontFamily: "'DM Sans', sans-serif", fontSize: "0.84rem",
        color: "rgba(255,235,250,0.6)", lineHeight: 1.85, marginBottom: 20,
        borderLeft: "2px solid rgba(255,107,157,0.25)",
        paddingLeft: 14,
      }}>
        I build things that work and communicate ideas that matter. Master's in Information Systems Engineering &amp; Data Science · Full Stack Dev at Rosa Luxemburg Stiftung · Erasmus+ at HU Utrecht. Five roles, three countries, six languages — and still learning.
      </p>

      {/* ── Stats ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 6, marginBottom: 20 }}>
        {STATS.map((s) => (
          <div key={s.label} style={{ ...card, padding: "11px 6px", textAlign: "center" }}>
            <p style={{ fontSize: "0.85rem", marginBottom: 2 }}>{s.icon}</p>
            <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.25rem", fontWeight: 600, color: "#FFB3D9", lineHeight: 1 }}>{s.value}</p>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.6rem", color: "rgba(255,235,250,0.38)", marginTop: 3 }}>{s.label}</p>
          </div>
        ))}
      </div>

      {/* ── Contact ── */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 20 }}>
        {CONTACTS.map((c) => (
          <a key={c.label} href={c.href} target="_blank" rel="noopener noreferrer" style={{
            display: "flex", alignItems: "center", gap: 10,
            ...card, padding: "9px 13px", textDecoration: "none",
            transition: "background 0.2s, border-color 0.2s",
          }}>
            <span style={{ color: c.color, opacity: 0.85, flexShrink: 0, display: "flex" }}>{c.icon}</span>
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.78rem", color: "rgba(255,235,250,0.7)", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {c.label}
            </span>
          </a>
        ))}
      </div>

      {/* ── Actions ── */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <a href="/resume.pdf" target="_blank" rel="noopener noreferrer" style={{
          display: "flex", alignItems: "center", gap: 7, flex: 1, justifyContent: "center",
          background: "linear-gradient(135deg, #FF6B9D, #C77DFF)",
          color: "#fff", border: "none", padding: "11px 18px",
          borderRadius: 50, fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.78rem", fontWeight: 600, textDecoration: "none",
          cursor: "none", boxShadow: "0 4px 20px rgba(255,107,157,0.3)",
          whiteSpace: "nowrap",
        }}>
          <FaFileAlt size={11} /> Download CV
        </a>
        {onNavigate && (
          <button onClick={() => onNavigate("contact")} style={{
            display: "flex", alignItems: "center", gap: 7, flex: 1, justifyContent: "center",
            background: "rgba(255,179,217,0.06)", color: "#FFB3D9",
            border: "1px solid rgba(255,179,217,0.28)", padding: "11px 18px",
            borderRadius: 50, fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.78rem", fontWeight: 500, cursor: "none",
            whiteSpace: "nowrap",
          }}>
            <FaEnvelope size={11} /> Contact me
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfileSection;
